import React from "react";
import { Button } from "@shopify/polaris";
import ReCAPTCHA from "components/ReCAPTCHA";
import BannerCustom from "components/Banners/BannerCustom";
import TaxIcon from '../../../../components/ProjectNavigationWindow/icons/tax-icon.svg';
import EPRIcon from '../../../../components/ProjectNavigationWindow/icons/epr-icon.svg';
import InvoiceIcon from '../../../../components/ProjectNavigationWindow/icons/invoice-icon.svg';
import AuthorizeIcon from '../../../../components/ProjectNavigationWindow/icons/authorize-icon.svg';
import IdkyIcon from '../../../../components/ProjectNavigationWindow/icons/idky-icon.svg';
import CheckedIcon from '../../../../img/core/checkmark.svg';

const categoryDescriptions = {
  "L`Tax": "Add L’Tax to your menu to manage tax obligations.",
  "L`EPR": "Add L’EPR to your menu to handle EPR requirements.",
  "L`Invoice": "Add L’Invoice to your menu to send and track e-invoices."
};

const projectsList = [
  {
    id: 1,
    img: TaxIcon,
    label: 'L’Tax',
    value: 'LTax',
    description:
        'VAT Registration・VAT Calculation・VAT reporting・VAT payment・Sales tax registration・Sales tax calculation・Sales tax reporting・Sales tax payment',
  },
  {
    id: 2,
    img: EPRIcon,
    label: 'L’EPR',
    value: 'LEPR',
    description: 'ERP Registration & Reporting',
  },
  {
    id: 3,
    img: InvoiceIcon,
    label: 'L’Invoice',
    value: 'LInvoice',
    description: 'Send & Receive Peppol Invoices',
  },
  {
    id: 6,
    img: AuthorizeIcon,
    label: 'L’Authorize',
    value: 'LAuthorize',
    description:
      'CE marking・UKCA marking・GSPR label・Authorized representative services for import',
  },
  {
    id: 0,
    img: IdkyIcon,
    label: 'I don’t know yet',
    value: 'Unknown',
  },
]

const SignUpStep2 = ({
  t,
  registering,
  onSubmit,
  onBack,
  onRecaptchaChange,
  onRecaptchaExpired,
  registerError,
  recaptchaSitekey,
  selectedApp,
  onAppSelect,
  registerProjectError
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div className='topbar-wrapper_block-modal_wrapper'>
          <h3 className='topbar-wrapper_block-modal_wrapper-title' style={{fontSize: 14, textAlign: 'center', fontWeight: 650}}>
            Select a Lappa App to begin
          </h3 >
          <p className='topbar-wrapper_block-modal_wrapper-subtitle' style={{fontSize: 12, textAlign: 'center'}}>
            Get started on Lappa apps. No worries, you can always add another app.
          </p >
          <ul className='topbar-wrapper_block-modal_wrapper-list'>
            {
              projectsList?.map((item,
                  index) => (
                  <li
                      className={`topbar-wrapper_block-modal_wrapper-list_item ${selectedApp === item.value ? 'selected-line' : ''}`}
                      key={index}
                      onClick={() => onAppSelect(item.value)}
                  >
                    <img
                        src={item?.img}
                        alt={item?.label}
                        className='topbar-wrapper_block-modal_wrapper-list_item-icon'
                    />
                    <div style={{marginLeft: '10px', paddingRight: 10, position: 'relative', width: '100%'}}>
                      <h3 className='topbar-wrapper_block-modal_wrapper-list_item-title'>{item.label}</h3>
                      {selectedApp === item.value && item.description ? (
                          <p className='topbar-wrapper_block-modal_wrapper-list_item-descriptoin'>
                            {item.description}
                          </p>
                      ) : null}
                      <div style={{position: 'absolute', right: 0, top: '-10px', display: selectedApp === item.value ? 'block' : 'none'}}>
                        <img
                            src={CheckedIcon}
                            alt='CheckedIcon'
                        />
                      </div>
                    </div >
                  </li >
              ))
            }
          </ul >
        </div >
    </div>
    {(registerError || registerProjectError) && (
      <div style={{ marginBottom: 16, width: "100%" }}>
        <BannerCustom
          status="error"
          message={registerError || registerProjectError}
        />
      </div>
    )}
    <div style={{marginBottom: 16}}>
      <ReCAPTCHA
        sitekey={recaptchaSitekey}
        onChange={onRecaptchaChange}
        onExpired={onRecaptchaExpired}
      />
    </div>
    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', marginBottom: 16, marginTop: 16}}>
      <Button
          variant='tertiary'
          onClick={onBack}
          style={{ marginTop: 16 }}
      >
        {t("signUp.back", "Back")}
      </Button>
      <Button
          disabled={registering || !selectedApp}
          loading={registering}
          variant='primary'
          onClick={onSubmit}
      >
        {t("signUp.signUp")}
      </Button>
    </div>
  </div>
);

export default SignUpStep2;
